import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

export const WeekStepper = ({
  selectedWeek,
  onPreviousWeek,
  onNextWeek,
  onThisWeek,
  hasPreviousWeek,
  hasNextWeek,
}) => {
  const { t } = useTranslation("athlete-portal");

  return (
    <div className="week-stepper">
      <div className="week-stepper-nav">
        <button
          type="button"
          data-button-type="text-white"
          data-icon-only
          onClick={onPreviousWeek}
          disabled={!hasPreviousWeek}
        >
          <SvgIcon src="/img/new-icons/arrow-left.svg" />
        </button>
        <span className="week-stepper-label">
          {t("annualPlanner.week")} {moment(selectedWeek).format("MMM D, YYYY")}
        </span>
        <button
          type="button"
          data-button-type="text-white"
          data-icon-only
          onClick={onNextWeek}
          disabled={!hasNextWeek}
        >
          <SvgIcon src="/img/new-icons/arrow-right.svg" />
        </button>
      </div>
      <button
        type="button"
        data-button-type="outline"
        className="week-stepper-this-week summary-goals-empty-cta"
        onClick={onThisWeek}
      >
        <span>{t("annualPlanner.thisWeek")}</span>
      </button>
    </div>
  );
};
